import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import eventBus from '../../../common/js/event-bus/event-bus';

export default {
	name: 'babyloanKoForm',
	mixins: [validationMixin],
	data() {
		return {
			questions: [
				{
					id: 'q1',
					label: 'Házasságban él és a feleség nem töltötte be a 41. életévét?',
					answer: null
				},
				{
					id: 'q2',
					label: 'Legalább egyikőjük rendelkezik 3 év folyamatos társadalom biztosítási (TB) jogviszonnyal?',
					tooltip:
						'Nappali felsőoktatási intézményben eltöltött tanulmány vagy más állam TB ellátása is beletartozik, ' +
						'ha 30 napnál hosszabb megszakítás nincs és a benyújtást megelőző 180 napban tb. jogviszonyban kell telnie.',
					answer: null
				},
				{
					id: 'q3',
					label: 'Mindketten rendelkeznek magyarországi lakcímmel?',
					answer: null
				},
				{
					id: 'q4',
					label: 'Ha a házaspár már legalább egy gyereket nevel, akkor egyikőjük az első házasságában él?',
					answer: null
				}
			],
			subquestions: [
				{
					id: 'sq1',
					label: 'Szerepel valamelyikük a KHR (régi nevén BAR lista) rendszerben mulasztással?',
					tooltip: 'A KHR rendszer egy hitelinformációs adatbázis, amit a hazai bankok és hitelintézetek működtetnek.',
					answer: null,
					reverseAnswer: true
				},
				{
					id: 'sq2',
					label: 'Mindketten büntetlen előéletűek és nincs NAV felé köztartozásuk?',
					tooltip: 'Nincs megállapított büntetőjogi felelősségük és nincs az állami adóhatóságnál nyilvántartott köztartozásuk.',
					answer: null
				},
				{
					id: 'sq3',
					label: 'Valamelyiküknek van min. 100 000 Ft összegű munkabérből vagy vállalkozásból származó jövedelme?',
					tooltip: 'A munkabérből, vállalkozásból vagy nyugdíjból származó jövedelem is ide számít.',
					answer: null
				}
			],
			subanswers: [],
			model: {
				answer: [],
				subanswer: []
			},
			answer: [],
			showSubquestions: false
		};
	},
	validations: {
		questions: {
			required,
			$each: {
				answer: {
					required
				}
			}
		},
		subquestions: {
			required,
			$each: {
				answer: {
					required
				}
			}
		}
	},
	props: {
		showKoForm: Boolean
	},
	methods: {
		sendForm() {
			if (!this.showSubquestions && this.isKoFilterValid(this.questions)) {
				this.showSubQuestions();
			} else if (this.isKoFilterValid(this.questions) && this.isKoFilterValid(this.subquestions)) {
				this.$emit('on-submit', true);
				this.$gtm.trackEvent({
					event: 'expectingBabyKOSuccess'
				});
			} else {
				this.$emit('on-submit', false);
				this.$gtm.trackEvent({
					event: 'expectingBabyKOFail'
				});
			}
		},
		showSubQuestions() {
			this.showSubquestions = true;
		},
		isKoFilterValid(questions) {
			let koFilterValid = true;
			questions.forEach((question) => {
				if ((question.answer.includes('no') && !question.reverseAnswer) || (question.answer.includes('yes') && question.reverseAnswer)) {
					koFilterValid = false;
				}
			});
			return koFilterValid;
		},
		resetKoForm() {
			this.questions.forEach((question) => {
				question.answer = null;
			});
			this.subquestions.forEach((subquestion) => {
				subquestion.answer = null;
			});
			this.showSubquestions = false;
		}
	},
	created() {
		eventBus.$on('modal-opened', (modalId) => {
			if (modalId == 'babyloan_ko_modal') {
				this.resetKoForm();
			}
		});
	}
};
